<template>
  <div
    v-if="$store.state.appDetails?.headline?.message"
    class="border-b text-gray-800 p-2 py-1 flex items-center"
  >
    <div class="relative h-2 w-2">
      <p
        class="h-2 w-2 absolute top-0 left-0 animate-ping bg-bnb-mustard rounded-full"
      ></p>
      <p class="h-2 w-2 absolute top-0 left-0 bg-bnb-mustard rounded-full"></p>
    </div>
    <p class="flex-1 text-sm font-medium">
      {{ $store.state.appDetails?.headline?.message }}
    </p>
  </div>
  <div
    class="relative h-full flex flex-col pb-14 p-2 overflow-y-hidden sm:space-y-10"
  >
    <div class="p-1">
      <img
        alt="logo"
        class="h-8 top-0 rounded-full"
        src="@/assets/logofullblack.png"
        @click="$router.go(-1)"
      />
    </div>
    <div class="overflow-y-scroll flex-1 sm:space-y-10">
      <Offers />
      <div class="flex relative justify-end px-1">
        <button
          @click="$store.commit('currentComponent', 'Menu')"
          class="bg-bnb-mustard rounded-md py-1 text-xl animate-fall-5 active:bg-bnb-brown shadow-md px-2 font-bold text-white text-right"
        >
          MENU
        </button>
      </div>
      <p class="text-gray-700 font-medium tracking-tight text-lg">
        Welcome,
        <span class="font-semibold text-xl" v-if="firstName">{{
          firstName
        }}</span>
        <span class="font-semibold text-xl" v-else>Batter</span>
      </p>
      <ReservationCard class="mt-4" />
      <DaySpecial class="mt-4" />
      <Recent class="mt-4" />
    </div>
  </div>
</template>

<script>
import Offers from "@/views/home/Offers.vue";
import ReservationCard from "@/views/home/ReservationCard.vue";
import DaySpecial from "@/views/home/special/DaySpecial.vue";
import Recent from "@/views/home/recent/Recent.vue";

export default {
  components: {
    Offers,
    ReservationCard,
    DaySpecial,
    Recent,
  },
  computed: {
    firstName() {
      return this.$store.state.user?.firstName;
    },
  },
};
</script>
